import styles from "../Banner/Banner.module.css";
import { Banner, BannerCTAs } from "../Banner/Banner";
import { IconCreditCard } from "src/components/ui-components/Icons/IconCreditCard";
import { Button } from "src/components/ui-components/Button/Button";
import { UnpaidInvoiceModal } from "./UnpaidInvoiceModal";

import { useState } from "react";
import { ActiveContext } from "shared/ContextSwitcher/store";
import { getThisTimeTomorrow } from "./getThisTimeTomorrow";
import {
  tryLocalStorageGetItem,
  tryLocalStorageSetItem,
} from "src/utils/storage/storage";

import Amplitude from "src/services/amplitude";

interface Props {
  activeContext: ActiveContext;
}

export function UnpaidInvoiceBanner(props: Props) {
  const { activeContext } = props;

  const [showModal, setShowModal] = useState(!getIsPostponedUntilLater());

  function closeModal() {
    setShowModal(false);
    setIsPostponedUntilTomorrow();
  }

  return (
    <>
      <Banner dismissable={false} color="error">
        <IconCreditCard />
        <div className={styles.copy}>Payment failed</div>

        <BannerCTAs>
          <Button
            size="S"
            theme="secondary"
            onClick={() => {
              Amplitude.trackEvent(`Unpaid Invoice Banner Button Clicked`);
              setShowModal(true);
            }}
          >
            See more
          </Button>
        </BannerCTAs>
      </Banner>

      <UnpaidInvoiceModal
        isOpen={showModal}
        close={closeModal}
        activeContext={activeContext}
      />
    </>
  );
}

const LS_KEY = "Unpaid_Ivoice_Remind_Me_After";

function getIsPostponedUntilLater() {
  const isoString = tryLocalStorageGetItem(LS_KEY);

  if (isoString === null) {
    return false;
  }

  const date = new Date(isoString);

  return date.valueOf() > new Date().valueOf();
}

function setIsPostponedUntilTomorrow() {
  const date = getThisTimeTomorrow();
  tryLocalStorageSetItem(LS_KEY, date.toISOString());
}
